export class NavCounts {
    public testKitCount: number = 1;
    public trackTestKitCount: number = 1

    public distributorCount: number = 1;
    public groupCount: number = 1;
    public groupBusinessActivityCount: number = 1;
    public businessActivityEventCount: number = 1;
    public groupSpeciesCount: number = 1;
    public siteCount: number = 1;
    public accountCount: number = 1;
   public accountPropertyCount: number = 1;
   public propertyActivitiesCount: number = 1;
   public propertyBusinessActivitiesCount: number = 1;
    public propertyCalendarCount: number = 1;
    public propertyContactCount: number = 1;
    public propertyPaddockCount: number = 1;
    public propertySpeciesCount: number = 1;
    public accountSubscriptionCount: number = 1;

    public sharedDataBreedCount: number = 1;
    public sharedDataCountryCount: number = 1;
    public sharedDataCurrencyCount: number = 1;
    public sharedDataDisclaimerCount: number = 1;
    public sharedDataEventCount: number = 1;
    public sharedDataProductCount: number = 1;
    public sharedDataSampleIssueCount: number = 1;
    public sharedDataSeasonCount: number = 1;
    public sharedDataSpeciesCount: number = 1;
    public sharedDataStockClassCount: number = 1;
    public sharedDataStockConditionCount: number = 1;
    public sharedDataSubscriptionCount: number = 1;
    public sharedDataTestCount: number = 1;
    public sharedDataParticlesCount: number = 1;
    public sharedDataParticleGroupsCount: number = 1;
    public sharedDataParticleParticlesCount: number = 1;

    public rataPlanCalendarCount: number = 1;
    public rataPlanActivityDatesCount: number = 1;

    public marketingCarouselCount: number = 1;
    public marketingNoticesCount: number = 1;

    public rataPlatformFeatureCount: number = 1;
    public rataPlatformErrorPagesCount: number = 1;

    public applicationCount: number = 1;
    public environmentCount: number = 1;
    public sectionCount: number = 1;
    public workspaceCount: number = 1;
    
    public isProcessingSite: boolean = false;

    public unMarkedUpSampleCount: number = 0;

    public markupPendingResultsCount: number = 0;
    public markupResultsCount: number = 0;
    
   public userGuideCount: number = 1;

   public exportFilesCount: number = 0;
   
    public cloudSubmissionCount: number = 1;
}